import React from 'react';
import { Link } from 'react-router-dom';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Cell } from 'recharts';
import { FileDown, KeyRound, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { downloadFile, errMsg, fmtDate } from '../../api';

const tip = { contentStyle: { background: '#0B0D13', border: '1px solid rgba(0,240,255,0.35)', fontSize: 12, fontFamily: 'JetBrains Mono' }, labelStyle: { color: '#00F0FF' }, itemStyle: { color: '#F0F4F8' } };
const COLS = ['#FF2E4D', '#FFB800', '#9D4EDD', '#00F0FF', '#00FF87'];

function Sources({ sources }) {
  if (!sources.length) return <p className="text-xs soc-muted soc-mono">I numeri per fonte sono nel report allegato.</p>;
  return (
    <ResponsiveContainer width="100%" height={Math.max(120, sources.length * 34)}>
      <BarChart data={sources} layout="vertical" margin={{ left: 10, right: 20 }}>
        <XAxis type="number" allowDecimals={false} tick={{ fill: '#8A99AD', fontSize: 11 }} axisLine={false} tickLine={false} />
        <YAxis type="category" dataKey="source" width={110} tick={{ fill: '#F0F4F8', fontSize: 11 }} axisLine={false} tickLine={false} />
        <Tooltip {...tip} cursor={{ fill: 'rgba(0,240,255,0.05)' }} />
        <Bar dataKey="count" name="Credenziali" radius={[0, 3, 3, 0]}>{sources.map((s, i) => <Cell key={s.source} fill={COLS[i % COLS.length]} />)}</Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}

export default function CriPanel({ cri, pending }) {
  const r = cri?.cri || {};
  return (
    <div className="soc-card p-5 mt-4" data-testid="cri-panel">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-3"><p className="soc-title">Cyber Risk Investigation</p>
        <Link to="/portal/richieste/data_leak" className="soc-mono text-[11px] text-[#00F0FF] hover:underline" data-testid="cri-request-link">{cri ? 'NUOVA INDAGINE' : 'RICHIEDI L\'INDAGINE'} →</Link></div>
      {pending > 0 && <p className="soc-mono text-xs text-[#FFB800] inline-flex items-center gap-2 mb-3" data-testid="cri-pending"><Loader2 size={13} className="animate-spin" />INDAGINE IN CORSO · l'esito comparirà qui</p>}
      {!cri ? <p className="text-sm soc-muted" data-testid="cri-empty">Nessun esito: con il dominio aziendale Smart Info calcola il Cyber Risk Index e cerca le credenziali già esfiltrate su Web, Deep Web e Dark Web.</p> : (
        <div className="grid lg:grid-cols-[220px_1fr] gap-5">
          <div className="space-y-3">
            <div><p className="soc-mono text-[10px] soc-muted">CYBER RISK INDEX · {cri.scope}</p><p className="soc-mono text-4xl font-extrabold text-[#00F0FF]" style={{ textShadow: '0 0 18px #00F0FF66' }} data-testid="cri-index">{r.index != null ? Number(r.index).toLocaleString('it-IT') : '--'}</p></div>
            <div><p className="soc-mono text-[10px] soc-muted inline-flex items-center gap-1.5"><KeyRound size={12} />CREDENZIALI ESFILTRATE</p><p className="soc-mono text-3xl font-extrabold text-[#FF2E4D]" data-testid="cri-total">{r.total ?? '--'}</p></div>
            <p className="soc-mono text-[10px] soc-muted">ESITO DEL {fmtDate(cri.updated_at)} · PRATICA {cri.ref}</p>
            {(cri.results || []).map((f) => <button key={f.id} onClick={() => downloadFile(`/requests/requests/${cri.id}/files/${f.id}`, f.filename).catch((e) => toast.error(errMsg(e)))} className="soc-ghost h-8 px-3 text-xs w-full" data-testid={`cri-file-${f.id}`}><FileDown size={13} /><span className="truncate">{f.filename}</span></button>)}
          </div>
          <div className="min-w-0"><p className="soc-mono text-[10px] soc-muted mb-2">CREDENZIALI PER FONTE</p><Sources sources={r.sources || []} /></div>
        </div>
      )}
    </div>
  );
}
